import { ConfigService } from "@core/config/app.config.service";

export class Api {
    private static apiUrlGatewayProcesos: string;
    private static baseUrlAPI: string;
    private static apiUrlApp: string;
    private static apiUrlBeneficiarios: string;
    private static apiUrlAfiliacion: string;
    private static apiUrlClientes: string;
    private static apiUrlDocumentos: string;
    private static apiUrlEmpleados: string;
    private static apiUrlAfiliacionDocumento: string;
    private static apiUrlEntidad: string;

    // Inicializa las variables desde el objeto config
    static initialize(configService: ConfigService): void {
        const config = configService.config;

        if (!config) {
            throw new Error('Config has not been loaded yet!');
        }

        Api.apiUrlGatewayProcesos = config.apiUrls.urlGatewayProcesos;
        Api.baseUrlAPI = `${config.apiUrls.urlGatewayProcesos}/proxy/afiliaciones`;
        Api.apiUrlApp = `${config.apiUrls.urlGatewayProcesos}/proxy/admin/app/`;
        Api.apiUrlBeneficiarios = `${config.apiUrls.urlGatewayProcesos}/proxy/empleados/beneficiario/`;
        Api.apiUrlAfiliacion = `${config.apiUrls.urlGatewayProcesos}/proxy/afiliaciones/afiliacion`;
        Api.apiUrlClientes = `${config.apiUrls.urlGatewayProcesos}/proxy/clientes/cliente`;
        Api.apiUrlDocumentos = `${config.apiUrls.urlGatewayProcesos}/proxy/empleados/documento`;
        Api.apiUrlEmpleados = `${config.apiUrls.urlGatewayProcesos}/proxy/empleados/empleado`;
        Api.apiUrlAfiliacionDocumento = `${config.apiUrls.urlGatewayProcesos}/proxy/afiliaciones/afiliacion_documento/`;
        Api.apiUrlEntidad = `${config.apiUrls.urlGatewayProcesos}/proxy/entidad/entidad`;
    }

    // Propiedades que generan las URLs con base en las variables inicializadas
    static get BaseUrlGatewayProcesos(): string {
        return Api.apiUrlGatewayProcesos;
    }

    static get BaseUrlAfiliacion(): string {
        return Api.baseUrlAPI;
    }

    static get BaseUrl(): string {
        return Api.baseUrlAPI;
    }

    static get BaseUrlApp(): string {
        return Api.apiUrlApp;
    }

    static get BaseUrlBeneficiarios(): string {
        return Api.apiUrlBeneficiarios;
    }

    static get urlLogin(): string {
        return `${Api.BaseUrlApp}token/`;
    }

    static get comboBox(): string {
        return `${Api.BaseUrl}api.combobox`;
    }

    static get url_parametro(): string {
        return `${Api.BaseUrlApp}parametro`;
    }

    static get urlAfiliacion(): string {
        return Api.apiUrlAfiliacion;
    }

    static get url_departamentos(): string {
        return `${Api.BaseUrlApp}departments/`;
    }

    static get url_countries(): string {
        return `${Api.BaseUrlApp}countries/`;
    }

    static get url_ciudades(): string {
        return `${Api.BaseUrlApp}cities`;
    }

    static get urlEntidad(): string {
        return Api.apiUrlEntidad;
    }

    static get urlCliente(): string {
        return Api.apiUrlClientes;
    }

    static get urlDocumento(): string {
        return Api.apiUrlDocumentos;
    }

    static get urlDocumentoAnulacion(): string {
        return `${Api.baseUrlAPI}/afiliacion_documento`;
    }

    static get urlDocumentoEmpleado(): string {
        return `${Api.apiUrlEmpleados}/empleado_persona_documento`;
    }

    static get urlDocumentoBeneficiarios(): string {
        return `${Api.apiUrlEmpleados}/beneficiario_persona_documento`;
    }

    static get crear_afiliacion_individual(): string {
        return `${Api.apiUrlEmpleados}/crear_afiliacion_individual`;
    }

    static get urlAfiliacionDocumento(): string {
        return Api.apiUrlAfiliacionDocumento;
    }

    static get urlEmpleado(): string {
        return Api.apiUrlEmpleados;
    }

    static get urlBeneficiarios(): string {
        return Api.apiUrlBeneficiarios;
    }

    static get urlDocumentoPersonas(): string {
        return Api.apiUrlDocumentos;
    }

    static get url_auto_ingreso(): string {
        return `${Api.BaseUrlApp}auto_sign`;
    }

    static get url_consulta_firma_documentos(): string {
        return `${Api.urlAfiliacion}/afiliacion/firma/documentos`;
    }

    static get url_firmar_documentos(): string {
        return `${Api.urlAfiliacion}/afiliacion/firma/digital`;
    }

    static get urlDocumentoResultadoTables(): string {
        return `${Api.BaseUrlAfiliacion}/afiliacion/download/document/`;
    }

    static get refreshPermissions(): string {
        return `${Api.BaseUrlApp}refresh_permissions/`;
    }
}
